import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconPrepareProps } from './IconPrepare.types'
import * as Styled from './styles/IconPrepare.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPrepare: FC<IconPrepareProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPrepareProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconPrepareProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M91.91 27.84v15.79m-7.76-7.9h15.53m-15.53 0h15.53M59.73 107.6v31.6m-15.57-15.8h31.13m15.7-48.64L75.82 89.93m66.15 35.82-15.16 15.16M35.94 75.76a.52.52 0 0 1 .5.5.5.5 0 0 1-.5.5'
            vectorEffect='non-scaling-stroke'
          />
          <path d='M35.94 75.51a.78.78 0 0 1 0 1.56' vectorEffect='non-scaling-stroke' />
          <rect
            height='143.87'
            width='23.89'
            rx='11.94'
            transform='rotate(-44.68 108.864 108.124)'
            vectorEffect='non-scaling-stroke'
            x='96.91'
            y='36.19'
          />
          <circle cx='131.83' cy='59.87' r='15.75' vectorEffect='non-scaling-stroke' />
          <circle cx='83.89' cy='147.87' r='1.04' vectorEffect='non-scaling-stroke' />
          <circle cx='83.89' cy='147.87' r='2.51' vectorEffect='non-scaling-stroke' />
          <circle cx='83.89' cy='147.87' r='.19' vectorEffect='non-scaling-stroke' />
          <circle cx='163.92' cy='44.48' r='.49' vectorEffect='non-scaling-stroke' />
          <circle cx='163.92' cy='44.48' r='.09' vectorEffect='non-scaling-stroke' />
          <circle cx='35.94' cy='76.25' r='.49' vectorEffect='non-scaling-stroke' />
          <circle cx='35.94' cy='76.25' r='.78' vectorEffect='non-scaling-stroke' />
          <circle cx='31.94' cy='47.87' r='3.98' vectorEffect='non-scaling-stroke' />
          <circle cx='31.94' cy='47.87' r='.81' vectorEffect='non-scaling-stroke' />
          <circle cx='163.92' cy='44.48' r='2.51' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconPrepare
